import React from 'react';
import LoanTypeForm from './LoanTypeForm';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

/** Crear tipo de préstamo. */
const LoanTypeNew: React.FC<ShowAlerts> = (props) => <LoanTypeForm {...props} />;

export default LoanTypeNew;
